import { HexisSymbol } from '@marcianus/design/components';

import { initials } from '@/lib/text';

// ╔══════════════════════════════════════════════════════════════════════════╗
// ║ QUEM FALA, VÊ-SE — e vê-se igual nos três chats.                          ║
// ║                                                                          ║
// ║ As mensagens do utilizador mostravam um ícone genérico de «pessoa»: numa  ║
// ║ conversa em que só há dois interlocutores, o próprio utilizador aparecia  ║
// ║ como um desconhecido. A foto do perfil já existia (`avatar_url`) e nunca  ║
// ║ era usada aqui.                                                          ║
// ║                                                                          ║
// ║ Degradação em três degraus, porque nem toda a gente tem foto:            ║
// ║   foto → iniciais do nome → ícone genérico.                              ║
// ║ Um avatar que falha a carregar cai para as iniciais em vez de deixar um   ║
// ║ quadrado partido (`onError`) — a imagem vem de um CDN externo e falha.   ║
// ╚══════════════════════════════════════════════════════════════════════════╝

export function ChatAvatar({ de, nome, foto }: {
  /** `hexis` desenha a marca; `eu` desenha a pessoa. */
  de: 'hexis' | 'eu';
  nome?: string | null;
  foto?: string | null;
}) {
  if (de === 'hexis') {
    return <span className="chat-avatar" aria-hidden><HexisSymbol size={15} /></span>;
  }
  return (
    <span className="chat-avatar" aria-hidden>
      {foto
        ? <img src={foto} alt="" loading="lazy"
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }}
            onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }} />
        : <span style={{ fontSize: 'var(--fs-micro)', fontWeight: 700, color: 'var(--fg-60)' }}>
            {initials(nome)}
          </span>}
    </span>
  );
}
